import type { ReactNode } from "react";
import type { GenerativeCardVariant } from "./types";

const VARIANT_CLASS: Record<GenerativeCardVariant, string> = {
  default: "border-border bg-card",
  "hitl-pending": "border-border bg-card",
  "hitl-urgent": "border-app-danger/40 bg-card",
  "hitl-resolved": "border-border bg-muted/40 opacity-60",
  "upgrade-preview": "border-white/10 bg-background/80)] backdrop-blur-xl",
  "upgrade-compact": "border-border bg-card",
  chart: "border-teal-500/20 bg-teal-500/[0.06]",
  "tool-completed": "border-border bg-card",
};

export function GenerativeCardRoot({ variant = "default", children, className }: {
  variant?: GenerativeCardVariant;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={`rounded-xl border p-3.5 text-card-foreground shadow-sm ${VARIANT_CLASS[variant]} ${className ?? ""}`}>
      {children}
    </div>
  );
}

export function GenerativeCardHeader({ children }: { children: ReactNode }) {
  return <div className="mb-2 flex items-center gap-2 border-b border-border/60 pb-2">{children}</div>;
}

export function GenerativeCardBody({ children }: { children: ReactNode }) {
  return <div className="mb-2 text-sm text-foreground">{children}</div>;
}

export function GenerativeCardActions({ children, columns = 2 }: {
  children: ReactNode;
  columns?: 2 | 3;
}) {
  return (
    <div className={`grid gap-1.5 ${columns === 3 ? "grid-cols-3" : "grid-cols-2"}`}>
      {children}
    </div>
  );
}

export function GenerativeCardFooter({ children }: { children: ReactNode }) {
  return <div className="mt-2 flex justify-center gap-3 text-[10px] text-muted-foreground">{children}</div>;
}
